import type { FleetMachineApproval, FleetMachineOverview } from '@immo/api-contract';

// `pending` machines first, longest-waiting on top; every other machine after,
// by name. The overview response orders by machine uuid, so this sort is the
// page's own job (IMM-910.7 Decisions).
//
// The machine list is an index an operator reads by name, so it is ordered by
// the one thing that does not move: last contact reshuffled the rail under
// the cursor on every 10s poll. The pending group keeps its waiting order —
// there, who has waited longest IS the question.
export function groupAndSort(machines: ReadonlyArray<FleetMachineOverview>): {
  readonly pending: ReadonlyArray<FleetMachineOverview>;
  readonly machines: ReadonlyArray<FleetMachineOverview>;
} {
  const isPending = (approval: FleetMachineApproval) => approval === 'pending';

  const pending = machines
    .filter((machine) => isPending(machine.approval))
    .slice()
    .sort((a, b) => Date.parse(a.firstSeenAt) - Date.parse(b.firstSeenAt));

  const rest = machines
    .filter((machine) => !isPending(machine.approval))
    .slice()
    .sort((a, b) => a.name.localeCompare(b.name, 'de-DE'));

  return { pending, machines: rest };
}
